import {FaAward} from "react-icons/fa";
import {TbBooks} from "react-icons/tb";
import {BiHappyHeartEyes} from "react-icons/bi"
 

const data=[
    {id:1,icon:<FaAward/>,title:"Education",des:'bachelors degree in Computer Science'},
    {id:2,icon:<TbBooks/>,title:"Projects",des:'10+ completed'},
    {id:3,icon:<BiHappyHeartEyes/>,title:"work Experience",des:'1000+ Hours '}

]

export default data;
